import {useState, useEffect, useMemo} from 'react';
import Select from 'react-select';
import { connect } from 'react-redux';
import { useTheme } from '@mui/material/styles';
import AccionesService from '../../services/acciones.service';

const SelectAcciones = ({
    id,
    value,
    onChange,
    isInvalid,
    isClearable,
    disabled,
    stack,
    ...defaultProps
}) => {
    const theme = useTheme();
    const isDarkMode = theme.palette.mode === 'dark';
    const [items, setItems] = useState([]);
    const [options, setOptions] = useState([]);
    const [selectedValue, setSelectedValue] = useState();
    const actualizar = async() => {
        await AccionesService.getAll().then((response) => {
            setItems(response);
        });
    }
    const onSelectValue = (ev) => {
        setSelectedValue(ev);
        if(Array.isArray(ev)){
            onChange(ev.map(e=>{
                const item = items.find(it=>it.id_ac === e.value);
                return {
                    ...e,
                    item: item,
                }
            }));
        } else if(ev){
            ev.item = items.find(it=>it.id_ac === ev.value);
            onChange(ev);
        } else {
            onChange(null);
        }
    };
    useEffect(() => {
        actualizar();
    }, []);
    useEffect(() => {
        if(items?.length > 0){
            const newOptions = items.map((item) => {
                return {
                    value: item.id_ac,
                    label: item.nombre_ac,
                };
            });
            setOptions(newOptions);
            if(Array.isArray(value)){
                setSelectedValue(value?.map(va=>{
                    const item = items.find(it=>it.id_ac === va);
                    if(item){
                        return {
                            label:item.nombre_ac,
                            value:item.id_ac,
                        };
                    }
                    return null
                }))
            }
        }
    }, [items]);

    // Actualizar selectedValue cuando cambia la prop value externamente
    useEffect(() => {
        if(items?.length > 0 && Array.isArray(value)){
            setSelectedValue(value?.map(va=>{
                const item = items.find(it=>it.id_ac === va);
                if(item){
                    return {
                        label:item.nombre_ac,
                        value:item.id_ac,
                    };
                }
                return null
            }).filter(v => v !== null))
        }
    }, [value, items]);

    const customStyles = useMemo(() => ({
        menuPortal: (base) => ({...base, zIndex: 9999}),
        menu: (provided) => ({
            ...provided,
            backgroundColor: isDarkMode ? '#2d3a52' : '#fff',
        }),
        option: (provided, state) => ({
            ...provided,
            color: state.isSelected 
                ? (isDarkMode ? '#90caf9' : '#fff') 
                : (isDarkMode ? '#e0e0e0' : '#000'),
            background: state.isSelected 
                ? (isDarkMode ? '#1a3a5c' : '#0364ff') 
                : (isDarkMode ? '#2d3a52' : '#fff'),
            '&:hover': {
                backgroundColor: isDarkMode ? '#3d4a62' : '#02378c',
                color: isDarkMode ? '#e0e0e0' : '#e0e0e0',
            },
        }),
        multiValue: (styles, { data }) => {
            return {
                ...styles,
                backgroundColor: isDarkMode ? '#1a3a5c' : '#0364ff',
                borderRadius: 5,
                border: isDarkMode ? '1px solid #fff' : 'none',
                border: isDarkMode ? '1px solid #fff' : 'none',
            };
        },
        multiValueLabel: (styles, { data }) => ({
            ...styles,
            color: '#fff',
            borderRadius: 5
        }),
        multiValueRemove: (styles, { data }) => ({
            ...styles,
            color: '#fff',
            borderRadius: 5,
            '&:hover': {
                backgroundColor: isDarkMode ? '#3d4a62' : '#02378c',
                color: '#fff',
            },
        }),
        control: (styles) => ({
            ...styles,
            borderRadius: 7,
            borderColor: isDarkMode ? '#3d4a62' : 'gray',
            backgroundColor: isDarkMode ? '#2d3a52' : '#fff',
        }),
        singleValue: (styles) => ({
            ...styles,
            color: isDarkMode ? '#e0e0e0' : '#000',
        }),
        input: (styles) => ({
            ...styles,
            color: isDarkMode ? '#e0e0e0' : '#000',
        }),
        placeholder: (styles) => ({
            ...styles,
            color: isDarkMode ? '#b0bec5' : 'gray',
        }),
    }), [isDarkMode])
    return (
        <Select
            inputId={id}
            className={`react-select-container ${
                isInvalid ? 'is-invalid' : ''
            }`}
            styles={customStyles}
            menuPortalTarget={document.body}
            classNamePrefix="react-select"
            placeholder="Seleccione..."
            options={options}
            value={selectedValue}
            onChange={onSelectValue}
            isClearable={isClearable}
            menuShouldScrollIntoView
            menuPosition='absolute'
            menuPlacement='auto'
            {...defaultProps}
        />
    );
};

SelectAcciones.defaultProps = {
    isClearable: false,
    onChange: () => {},
};

const mapStateToProps = (state) => ({
    stack: state.modalProvider.stack,
})

const mapDispatchToProps = {}
export default connect(mapStateToProps, mapDispatchToProps)(SelectAcciones)

